import { useEffect, useRef } from "react"
import io from "socket.io-client"
import { useStore } from "../store"
// import { usePOIStore } from "./activePOIStore"

const TwoDBroadcaster = () => {
  const socket = useRef()
  const url = process.env.REACT_APP_MARKETING_SUITE
  const role = process.env.REACT_APP_ROLE

  const tooltipVisible = useStore(state => state.tooltipVisible)
  const setTooltipVisible = useStore(state => state.setTooltipVisible)

  const titleAnimate = useStore(state => state.titleAnimate)
  const setTitleAnimate = useStore(state => state.setTitleAnimate)

  const state = {
    tooltipVisible: tooltipVisible,
    titleAnimate: titleAnimate
  }

  useEffect(() => {
    socket.current = io(url)
    socket.current.emit("subscribe-twodzustand", 1000)
    if (role === "recipient") {
      socket.current.on("twodzustand", actAptZustand => {
        setTooltipVisible(actAptZustand.tooltipVisible)
        setTitleAnimate(actAptZustand.fullScreenPlan)
      })
    }
    return () => socket.current.close()
  }, [state, role, url])

  useEffect(() => {
    if (role === "sender") {
      socket.current.emit("twodzustand", state)
    }
  }, [state, role, url])

  return null
}

TwoDBroadcaster.propTypes = {}

export default TwoDBroadcaster
